import { GuestModel } from 'api-hooks/guest';
import {
  CategoryTypeEnum,
  GenderTypeEnum,
  GuestRelationTypeEnum,
} from 'common/constants/enum';
import { FileFormSchema, PreferenceFormSchema } from 'common/form-schema';
import * as Yup from 'yup';

export const GuestPassportFormSchema = () =>
  Yup.object({
    id: Yup.string(),
    type: Yup.string().nullable().default(null),
    number: Yup.string().nullable().default(null),
    identifierNumber: Yup.string().nullable().default(null),
    familyName: Yup.string().nullable().default(null),
    givenName: Yup.string().nullable().default(null),
    nationality: Yup.string().nullable().default(null),
    issueState: Yup.string().nullable().default(null),
    placeOfBirth: Yup.string().nullable().default(null),
    dateOfBirth: Yup.date().nullable().default(null),
    expiredAt: Yup.date().nullable().default(null),
    files: Yup.array(FileFormSchema()).default([]),
    gender: Yup.string().default(GenderTypeEnum.Male),
  });

export const GuestApecCardFormSchema = () =>
  Yup.object({
    id: Yup.string(),
    type: Yup.string().default(''),
    number: Yup.string().default(''),
    name: Yup.string().default(''),
    applicationNumber: Yup.string().default(''),
    email: Yup.string().default(''),
    passportNumber: Yup.string().default(''),
    pin: Yup.string().default(''),
    expiredAt: Yup.date().nullable().default(null),
    files: Yup.array(FileFormSchema()).default([]),
  });

export const GuestAirlineFormSchema = () =>
  Yup.object({
    id: Yup.string(),
    airlineId: Yup.string().default(''),
    password: Yup.string().default(''),
    memberNumber: Yup.string().default(''),
    note: Yup.string().default(''),

    //additional information
    customId: Yup.string().default(''),
  });

export const GuestRelationFormSchema = () =>
  Yup.object({
    id: Yup.string(),
    guestId: Yup.string().default(''),
    type: Yup.string().default(GuestRelationTypeEnum.MainFamily),

    //additional information
    customId: Yup.string().default(''),
  });

export const GuestVisaFormSchema = () =>
  Yup.object({
    id: Yup.string(),
    visaDocumentId: Yup.string().default(''),
    number: Yup.string().default(''),
    issuedAt: Yup.date().nullable().default(null),
    expiredAt: Yup.date().nullable().default(null),
    files: Yup.array(FileFormSchema()).default([]),

    //additional information
    customId: Yup.string().default(''),
  });

export const GuestInsuranceFormSchema = () =>
  Yup.object({
    id: Yup.string(),
    number: Yup.string().default(''),
    issuedAt: Yup.date().nullable().default(null),
    expiredAt: Yup.date().nullable().default(null),
    // code: Yup.string().default(''),
    // preferenceId: Yup.string().default(''),
    files: Yup.array(FileFormSchema()).default([]),
    type: Yup.string().default(''),

    //additional information
    customId: Yup.string().default(''),
  });

export const GuestVaccineFormSchema = () =>
  Yup.object({
    id: Yup.string(),
    files: Yup.array(FileFormSchema()).default([]),

    //additional information
    customId: Yup.string().default(''),
  });

export const GuestOtherFormSchema = () =>
  Yup.object({
    id: Yup.string(),
    name: Yup.string().default(''),
    description: Yup.string().default(''),
    files: Yup.array(FileFormSchema()).default([]),

    //additional information
    customId: Yup.string().default(''),
  });

export const GuestFormSchema = () =>
  Yup.object({
    passport: GuestPassportFormSchema().nullable().default(null),
    apecCard: GuestApecCardFormSchema().nullable().default(null),
    title: Yup.string().nullable().default(null),
    name: Yup.string().default(''),
    alias: Yup.string().default(''),
    gender: Yup.string().default(GenderTypeEnum.Male),
    category: Yup.string().default(CategoryTypeEnum.Regular),
    birthPlace: Yup.string().default(''),
    birthDate: Yup.date().nullable().default(null),
    idNumber: Yup.string().default(''),
    phone: Yup.string().default(''),
    phone_2: Yup.string().default(''),
    airlines: Yup.array(GuestAirlineFormSchema()).default([]),
    relations: Yup.array(GuestRelationFormSchema()).default([]),
    visas: Yup.array(GuestVisaFormSchema()).default([]),
    insurances: Yup.array(GuestInsuranceFormSchema()).default([]),
    vaccines: Yup.array(GuestVaccineFormSchema()).default([]),
    others: Yup.array(GuestOtherFormSchema()).default([]),
    preferences: Yup.array(PreferenceFormSchema()).default([]),
    email: Yup.string().email().default(''),
    //addional information
    hasPassport: Yup.boolean().default(false),
    hasApecCard: Yup.boolean().default(false),
  });

export type GuestPassportFormType = Yup.InferType<
  ReturnType<typeof GuestPassportFormSchema>
>;

export type GuestApecCardFormType = Yup.InferType<
  ReturnType<typeof GuestApecCardFormSchema>
>;

export type GuestAirlineFormType = Yup.InferType<
  ReturnType<typeof GuestAirlineFormSchema>
>;

export type GuestRelationFormType = Yup.InferType<
  ReturnType<typeof GuestRelationFormSchema>
>;

export type GuestVisaFormType = Yup.InferType<
  ReturnType<typeof GuestVisaFormSchema>
>;

export type GuestInsuranceFormType = Yup.InferType<
  ReturnType<typeof GuestInsuranceFormSchema>
>;

export type GuestVaccineFormType = Yup.InferType<
  ReturnType<typeof GuestVaccineFormSchema>
>;

export type GuestOtherFormType = Yup.InferType<
  ReturnType<typeof GuestOtherFormSchema>
>;

export type GuestFormType = Yup.InferType<
  ReturnType<typeof GuestFormSchema>
> & {
  data?: GuestModel;
};
